import { api, type RequestOptions } from "./client";

export interface CustomerDto {
  id:                string;
  display_name:      string;
  company_name:      string | null;
  phone:             string | null;
  email:             string | null;
  telegram_user_id:  number | null;
  trust_score:       number | null;
  created_at:        string;
}

export const customersApi = {
  list(limit = 50, opts?: RequestOptions): Promise<CustomerDto[]> {
    return api.get<CustomerDto[]>(`/customers?limit=${limit}`, opts);
  },

  get(customerId: string, opts?: RequestOptions): Promise<CustomerDto> {
    return api.get<CustomerDto>(`/customers/${customerId}`, opts);
  },
};
